
import SelectButton from '@/components/new/buttons/SelectButton.vue'
import CustomButton from '@/components/new/buttons/CustomButton.vue'
import { Vue, Component, Watch, Prop } from 'vue-property-decorator'

@Component({
    components: {
        SelectButton,
        CustomButton
    },
})

export default class TopItemPicker extends Vue {
    @Prop({ type: String, default: "Days" }) readonly rangeBy!: string;
    @Prop({ type: Number, default: 0 }) readonly weekStart!: number;
    @Prop({ type: Number, default: 0 }) readonly weekEnd!: number;
    @Prop({ type: Number, default: 0 }) readonly year!: number;
    @Prop({ type: String, default: "" }) readonly month!: string;
    @Prop({ type: Number, default: null }) readonly currentWeekNumber!: number;
    @Prop({ type: Number, default: null }) readonly quater!: number;
    @Prop({ type: String, default: "" }) readonly nextMonth!: string;

    get trailingText() {
        return this.rangeBy === 'Days' ? `${this.month} ${this.weekStart} - ${this.nextMonth} ${this.weekEnd}` : this.year
    }

    //get if isdays
    get isDays() {
        return this.rangeBy === 'Days'
    }

    get title() {
        switch (this.rangeBy) {
            case 'Days':
                return `Week ${this.currentWeekNumber}`
                break;
            case 'Weeks':
                return `Week ${this.currentWeekNumber}`
                break;
            case 'Months':
                return `Quarter ${this.quater}`
                break;
        }

    }

    next() {
        this.$emit('next')
    }

    prev() {
        this.$emit('prev')
    }

}
